import React from 'react';
import './Sidebar.css';
import NavLinks from './NavLinks';

const Sidebar = ({ isOpen, onClose }) => {
  return (
    <>
      <div className={`sidebar-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}></div>
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <button onClick={onClose} className="close-button" aria-label="Close menu">
            <svg className="close-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <nav className="sidebar-nav-container">
          {/* Pass the onClose function down as the onLinkClick prop */}
          <NavLinks isMobile={true} onLinkClick={onClose} />
        </nav>
      </div>
    </>
  );
};

export default Sidebar;